<template>
  <div class="LC_reduceCarbon" ref="LC_reduceCarbon">
    <div class="upBox" :class="{'upBox-visit': isVisit}">
      <div class="upBox-title">
        <div :class="{'isVisitStyle': isVisit}">
          <div>碳排放(t/吨钢)</div>
          <div v-if="!is89">「同比」</div>
        </div>
        <div v-if="!isVisit">
          <div>污染物(kg/吨钢)</div>
          <div v-if="!is89">「同比」</div>
        </div>
      </div>
      <div class="upBox-content-box">
        <div class="upBox-content-left">
          <div
            class="upBox-content-item"
            v-for="(item, i) in list1"
            :key="i"
            @click="toCo2Detail(item)"
          >
            <div class="item-left" :class="!is89 ? '' : '_89class'">
              <div class="item-name">
                <span v-if="item.type == 'CO2'"
                  >CO<sub class="set-gas-position">2</sub></span
                >
                <span v-else-if="item.type == 'SO2'"
                  >SO<sub class="set-gas-position">2</sub></span
                >
                <span v-else-if="item.type == 'NOx'"
                  >NO<sub class="set-gas-position">x</sub></span
                >
                <span v-else>{{ item.type }}</span>
              </div>
              <div class="item-value number">
                {{ item.value ? item.value : "--" }}
              </div>
            </div>
            <div class="item-right" v-if="!is89">
              <div 
                class="item-status"
                :class="{
                  up: upOrDown(item.percentage, 'up'),
                  down: upOrDown(item.percentage, 'down'),
                }"
              >
                {{ !is89 ? item.percentage + '%' : '----' }}
              </div>
              <div
                class="item-status-icon"
                v-if="!is89"
                :class="{
                  box2iup: upOrDown(item.percentage, 'up'),
                  box2idown: upOrDown(item.percentage, 'down'),
                }"
              ></div>
            </div>
          </div>
        </div>
        <div class="upBox-content-right" v-if="!isVisit">
          <div class="upBox-content-item" v-for="(item, i) in list2" :key="i">
            <div class="item-left" :class="!is89 ? '' : '_89class'">
              <div class="item-name">
                <span v-if="item.type == 'CO2'"
                  >CO<sub class="set-gas-position">2</sub></span
                >
                <span v-else-if="item.type == 'SO2'"
                  >SO<sub class="set-gas-position">2</sub></span
                >
                <span v-else-if="item.type == 'NOx'"
                  >NO<sub class="set-gas-position">x</sub></span
                >
                <span v-else>{{ item.type }}</span>
              </div>
              <div class="item-value number">
                {{ item.value ? item.value : "--" }}
              </div>
            </div>
            <div class="item-right" v-if="!is89">
              <div 
                class="item-status"
                :class="{
                  up: upOrDown(item.percentage, 'up'),
                  down: upOrDown(item.percentage, 'down'),
                }"
              >
                {{ !is89 ? item.percentage + '%' : '----' }}
              </div>
              <div
                v-if="!is89"
                class="item-status-icon"
                :class="{
                  box2iup: upOrDown(item.percentage, 'up'),
                  box2idown: upOrDown(item.percentage, 'down'),
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="downBox" >
      <div class="downBg"></div>
      <div class="chart_column" ref="chart"></div>
    </div>
  </div>
</template>

<script>
import getOptBar from "./chartBar.js";
import getOptBarVisit from "./chartBarVisit.js";
import { unwarp, toDecimal2 } from "@/utils/tools.js";
import co2Detail from "./components/co2Detail.vue";
import { mapGetters } from "vuex";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'LC_reduceCarbon.vue',
      computedName: '年度减污降碳水平',
      customerId: this.$store.state.customerId,
      list1: [],
      list2: [],
      dataList: [],
      chart: null,
      is89: false,
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    upOrDown() {
      return (val, type) => {
        if (type == "down") {
          if (val < 0) {
            return true;
          }
        } else if (type == "up") {
          if (val >= 0) {
            return true;
          }
        }
      };
    },
    isVisit() {
      return this.$store.state.isVisit
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.customerId == 89) {
      this.is89 = true
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.LC_reduceCarbon).outerWidth();
    let h = $(that.$refs.LC_reduceCarbon).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListDataUp();
    this.getListDataDown();
  },
  unmounted() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
      // clearTimeout(this.setTime1);
    }
  },
  //方法集合
  methods: {
    toCo2Detail(item) {
      if (item?.type == "CO2") {
        this.openCEPage();
      }
    },
    openCEPage() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(co2Detail, this.dialogCompontent);
    },
    async getListDataUp() {
      const getCarbonAndPollution =
        CONFIG.requestName + this.$apiOpt.getCarbonAndPollution;
      let res = await this.$apiUtils.get(getCarbonAndPollution, {
        customerId: this.customerId,
      });
      if (res.Carbon) {
        res.Carbon.map((item) => {
          item.value = toDecimal2(item.value);
        });
      }
      if (res.Pollution) {
        res.Pollution.map((item) => {
          item.value = toDecimal2(item.value);
        });
      }
      this.list1 = res.Carbon || [];
      this.list2 = res.Pollution || [];
    },
    async getListDataDown() {
      const emissionCompare = CONFIG.requestName + this.$apiOpt.emissionCompare;
      let res = await this.$apiUtils.get(emissionCompare, {
        customerId: this.customerId,
      });
      this.dataList = res || [];
      this.$nextTick(() => {
        this.getCharts();
      });
    },
    getCharts() {
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chart);
      }
      let dataObj = { typeId: [], myValue: [], otherValue: [] };
      this.dataList.forEach((item) => {
        dataObj.typeId.push(item.type);
        dataObj.myValue.push(item.emission);
        dataObj.otherValue.push(item.industryAverage);
      });
      // dataObj.typeId = ["CO2", "SO2", "NO2", "颗粒物"];
      // dataObj.myValue = ["1.75", "1.75", "1.75", "1.75"];
      // dataObj.otherValue = ["0.75", "2.75", "1.2", "1.15"];
      if (this.isVisit) { // 横向展示，并且只展示CO2
        dataObj.myValue = dataObj.myValue && [dataObj.myValue[0]] || []
        dataObj.otherValue = dataObj.otherValue && [dataObj.otherValue[0]] || []
        dataObj.typeId = dataObj.typeId && [dataObj.typeId[0]] || []
        unwarp(this.chart).setOption(getOptBarVisit(dataObj));
      } else {
        unwarp(this.chart).setOption(getOptBar(dataObj));
      }
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
.LC_reduceCarbon {
  width: 600px;
  height: 520px;
  padding-top: 59px !important;
  .upBox {
    @include bg-box(560px, 205px, "boxBg.png");
    .upBox-title {
      display: flex;
      flex-wrap: nowrap;
      height: 40px;
      > div {
        padding: 0 14px;
        width: 50%;
        display: flex;
        flex-wrap: nowrap;
        > div {
          width: 50%;
          text-align: center;
          height: 100%;
          line-height: 40px;
          font-weight: 500;
          color: #c8d8ff;
          white-space: nowrap;
        }
      }
    }
    .upBox-content-box {
      height: 165px;
      display: flex;
      justify-content: space-between;
      padding: 6px 11px;
      .upBox-content-left {
        width: 50%;
        .upBox-content-item {
          cursor: pointer;
        }
      }
      .upBox-content-right {
        width: 50%;
        .upBox-content-item {
          float: right;
        }
      }
      .upBox-content-item {
        @include bg-box(260px, 43px, "itemBg.png");
        margin-bottom: 10px;
        display: flex;
        .item-left {
          width: 143px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0px 9px;
          .item-name {
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
          }
          .item-value {
            font-size: 22px;
            font-weight: 400;
            color: #f4d29c;
          }
        }
        ._89class {
          width: 100% !important;
        }
        .item-right {
          width: 117px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding-right: 10px;
          padding-left: 10px;
          .item-status {
            font-size: 18px;
            font-weight: 400;
            margin-right: 6px;
          }
          .up {
            color: #ec2323;
          }
          .down {
            color: #7ff4b1;
          }
          .item-status-icon {
            @include bg-box(12px, 20px, "upicon.png");
          }
          .box2iup {
            @include bg-box(12px, 20px, "upicon.png");
          }
          .box2idown {
            @include bg-box(12px, 20px, "downicon.png");
          }
        }
      }
    }
  }
  .upBox-visit {
    @include bg-box(560px, 205px, "boxBg.png");
    .upBox-title {
      height: 50px;
      .isVisitStyle {
        width: 100%;
        div {
          // line-height: 90px;
          // font-size: 20px;
        }
      }
    }
    .upBox-content-box {
      .upBox-content-left {
        width: 100%;
        .upBox-content-item {
          width: 100%;
          background: none;
          .item-left {
            width: 50%;
            justify-content: space-between;
            .item-name {
              font-size: 30px;
            }
            .item-value {
              font-size: 36px;
            }
          }
          .item-right {
            width: 50%;
            justify-content: center;
            .item-status {
              font-size: 30px;
            }
            .box2iup {
              width: 18px;
              height: 30px;
            }
          }
        }
      }
    }
  }
  .downBox {
    height: 231px;
    position: relative;
    .downBg {
      height: 183px;
      width: 100%;
      top: 48px;
      position: absolute;
      background: linear-gradient(
        315deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(2, 3, 14, 0.2) 100%
      );
    }
    .chart_column {
      height: 231px;
    }
  }
}
</style>
